module.exports = __webpack_public_path__ + "static/media/Seagul.477d5768.mp3";